// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3NSCY","inputDescription":"styles_inputDescription__hDzC8"};